import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-story-player-dialog',
  standalone: true,
  imports: [],
  templateUrl: './story-player-dialog.component.html',
  styleUrl: './story-player-dialog.component.scss'
})
export class StoryPlayerDialogComponent {
  // create reference to dialog and pass the data type to pass to parent component when dialog is closed (boolean) to trigger save or cancel
  dialogRef = inject<DialogRef<'flag' | 'block' | 'report'>>(DialogRef<string>);
  data = inject(DIALOG_DATA);
}
